
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorway-move",
      function () {
        return require("private-next-pages/motorway-move.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorway-move"])
      });
    }
  